var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", {
      staticClass: "close-icon",
      attrs: { src: _vm.closeIcon, alt: "" },
      on: { click: _vm.close }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "preferences-modal" },
      [
        _c("employee-hub-service", {
          attrs: {
            "service-id": _vm.serviceId,
            "current-user-access-token": _vm.authResponse.accessToken
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b9664a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b9664a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-directory/ServiceModal.vue
// module id = null
// module chunks = 